export const colors = {
  NAVYBLUE: "#0E155B",
  GRAY: "#AEAEAE",
  LIGHT_GREY: "#CFCFCF",
  White: "#fff",
  LIGHT_GRAY: "#868686",
  DARK_GRAY: "#5E5E5E",
  NEUTRAL_NEUTRAL: "#363636",
  PURPLE: "#09005B",
  GREEN: "#00A603",
  DANGER: "#B00020",
  Primary: "#00C703",
  BLACK: "#0E0E0E",
  NEUTRAL_BLACK: "#363636",
  SECONDARY_GREY: "#8C8B8B",
  // PRIMARY_GREY: "#CECCDE",
  PRIMARY_GREY: "rgba(206, 204, 222, 0.4)",
  NEUTRAL_GREY: "#AFAFAF",

  general: {
    cetaceanBlue: "#09005B",
    vividMalachite: "#00C703",
    richBlack: "#010F1C",
    maastrichtBlue: "#011B32",
    brightGray: "#E8EAED",
    platinum: "#E6E6E6",
  },

  primary: {
    gainsBoro: "#D9D9E7",
    lavenderGray: "#BFC0D7",
    blueBell: "#9FA0C3",
    shadowBlue: "#7F80B0",
    darkBlueGray: "#5F619C",
    darkSlateBlue: "#3F4188",
    americanBlue: "#353671",
    indigoRainbow: "#2A2B5B",
    yankeesBlue: "#202144",
    darkGunmetal: "#15162D",
  },

  secondary: {
    teaGreen: "#CCF4CD",
    celadon: "#aaecab",
    pastelGreen: "#80e381",
    UFOGreen: "#55da57",
    limeGreen: "#2ad02d",
    vividMalachite: "#00c703",
    islamicGreen: "#00a603",
    green: "#008502",
    darkGreenX11: "#006402",
    forestGreen: "#004201",
    darkGreen: "#002801",
  },

  tertiary: {
    americanSilver: "#CECFD0",
    silverFoil: "#AEAEB1",
    taupeGray: "#85868A",
    graniteGray: "#5D5E64",
    onyx: "#35353D",
    chineseBlack: "#0C0D16",
    richBlack: "#0A0B12",
    vampireBlack: "#08090F",
    vampireBlackII: "#06070B",
    richBlackII: "#040407",
  },

  neutral: {
    white: "#FFFFFF",
    cultured: "#F7F7F7",
    americanSilver: "#CFCFCF",
    silverFoil: "#AFAFAF",
    oldSilver: "#868686",
    davysGrey: "#5E5E5E",
    jet: "#363636",
    smokyBlack: "#0E0E0E",
  },

  success: {
    magicMint: "#BDECCE",
    tealDeer: "#9DE2B6",
    mediumAquamarine: "#7CD89D",
    emerald: "#5BCF85",
    UFOGreen: "#3AC56C",
    seaGreen: "#30A45A",
  },

  warning: {
    champagne: "#FAE7CC",
    deepChampagne: "#F6D8AA",
    topaz: "#F1C480",
    sunray: "#EDB055",
    marigold: "#E89D2B",
    fulvous: "#E48900",
  },

  danger: {
    isabelline: "#F7E6E9",
    paleChestnut: "#E7B0BA",
    shimmeringBlush: "#DB8A98",
    popstar: "#ca546a",
    dingyDungeon: "#C0334D",
    alabamaCrimson: "#B00020",
  },

  ButtonBackgroundColors: {
    primaryDefaultButton: "#00A603",
    primarySelectedButton: "##006402",
    primaryMediumHoverButton: "#00A603", //small and medium has same color for hover state
    primaryBigHoverButton: "#006402", // like wise big and large
    primaryDisabledButton: "#AAECAB",

    secondaryDefaultButton: "#FFFFFF",
    secondarySelectedButton: "#80E381",
    secondaryHoverButton: "#00A603",
    secondaryDisabledButton: "#FFFFFF",

    GhostDefaultButton: "#FFFFFF",
    GhostSelectedButton: "#80E381",
    GhostHoverButton: "#00A603",
    GhostDisabledButton: "#FFFFFF",
  },

  ButtonColors: {
    primaryButton: "#FFFFFF", //same colors used for all type of Primry

    secondaryButton: "#00A603",
    secondaryprimaryDisabledButton: "#AAECAB",

    GhostButton: "#00A603",
    GhostDisabledButton: "#AFAFAF",
  },
};
